export enum ShipmentDeliveryServiceId {
    HomeDelivery = 'HomeDelivery', // SAP code: DPH
    PostOffice = 'PostOffice', // SAP code: DPP
    Postbox = 'Postbox', // SAP code: DPO
    ParcelPoint = 'ParcelPoint', // SAP code: DPT
    RuralParcel = 'RuralParcel', // SAP code: DPL
    // SAP code: Depends but it will be either HomeDelivery, PostOffice, Postbox, or ParcelPoint
    DomesticParcel = 'DomesticParcel',
    // SAP code: Depends but it will be either HomeDeliveryLetter, PostOfficeLetter or DeliverToRecipientOnlyAndHomeDelivery
    DomesticLetter = 'DomesticLetter',
    HomeDeliveryLetter = 'HomeDeliveryLetter', // SAP code: DRA
    PostOfficeLetter = 'PostOfficeLetter', // SAP code: DRP
    DeliverToRecipientOnlyAndHomeDelivery = 'DeliverToRecipientOnlyAndHomeDelivery', // SAP code: DRR
    InternationalUntraceableLetter = 'InternationalUntraceableLetter', // SAP code: OLU
    InternationalParcel = 'InternationalParcel', // SAP code: Depends but starts with O if outbound, I if inbound,
    InternationalLetter = 'InternationalLetter', // SAP code: Depends but starts with O if outbound, I if inbound
    Unknown = 'Unknown'
}
